import { useEffect, useRef } from 'react'
import SITE from '@/config/site'

/**
 * useAnalytics — inicializa Google Analytics UMA vez por sessão.
 * Chamar exclusivamente em App.tsx (nível raiz).
 */
export function useAnalytics() {
  const initialized = useRef(false)

  useEffect(() => {
    if (initialized.current) return
    if (!SITE.analytics.enabled) return

    const isLocalhost =
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'

    if (isLocalhost) return

    initialized.current = true

    if (document.querySelector(`script[data-gtag="${SITE.analytics.gtagId}"]`)) return

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${SITE.analytics.gtagId}`
    script.setAttribute('data-gtag', SITE.analytics.gtagId)

    script.onload = () => {
      const inline = document.createElement('script')
      inline.text = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${SITE.analytics.gtagId}');
      `
      document.head.appendChild(inline)
    }

    script.onerror = () => {
      console.warn('[Analytics] Falha ao carregar Google Tag Manager.')
    }

    document.head.appendChild(script)
  }, [])
}
